document.addEventListener("DOMContentLoaded", function() {
  // Get elements
  const colorVariantButtons = document.querySelectorAll('input[type="radio"][name^="Standard Colour"]');
  const customColorDisplayLink = document.getElementById("custom-color-display");
  const customColorHiddenInput = document.getElementById("custom-color-input-hidden");
  const customColorDisclaimer = document.getElementById("custom-color-disclaimer");
  const modalOverlay = document.getElementById("modalOverlay");
  const customColorModal = document.getElementById("customColorModal");
  const modalSubmitButton = document.getElementById("modal-submit-button");
  const modalColorInput = document.getElementById("modal-color-input");
  const addToCartForm = document.querySelector('form[action="/cart/add"]');
  
  // Elements for the new color picker
  const colorRangeDropdown = document.getElementById("color-range");
  const colorFamilyDropdown = document.getElementById("color-family");
  const colorFamilySection = document.getElementById("color-family-section");
  const colorSwatchSection = document.getElementById("color-swatch-section");
  const colorSwatchContainer = document.getElementById("color-swatch-container");

  let customColor = ""; // Variable to store the custom color
  let allColorData = []; // This will store the parsed CSV data

  const csvFilePath = 'https://cdn.shopify.com/s/files/1/0847/4460/1865/files/colours.csv?v=1323445694';  // CSV file path

  // Function to fetch and parse CSV
  const fetchCSVData = async function() {
    try {
      const response = await fetch(csvFilePath);
      const csvData = await response.text();
      parseCSVData(csvData);
      populateColorRangeDropdown(); // Populate color ranges after data is fetched
    } catch (error) {
      console.error("Error fetching CSV data:", error);
    }
  };

  // Function to parse CSV data into a usable format
  const parseCSVData = function(csvText) {
    const rows = csvText.split("\n").slice(1); // Skip header row
    allColorData = rows.map(row => {
      const [range, family, name, code, hex] = row.split(",");
      return { range, family, name, code, hex };
    });
  };

  // Function to get color ranges from the CSV data
  const getColorRanges = function() {
    const ranges = allColorData.map(item => item.range);
    return [...new Set(ranges)]; // Remove duplicates
  };

  // Function to get color families for a specific range
  const getColorFamiliesByRange = function(selectedRange) {
    const families = allColorData
      .filter(item => item.range === selectedRange)
      .map(item => item.family);
    return [...new Set(families)]; // Remove duplicates
  };

  // Function to get colors for a specific family
  const getColorsByFamily = function(selectedRange, selectedFamily) {
    return allColorData.filter(item => item.range === selectedRange && item.family === selectedFamily);
  };

  // Function to populate color range dropdown
  const populateColorRangeDropdown = function() {
    const ranges = getColorRanges();
    colorRangeDropdown.innerHTML = '<option value="">-- Choose a Range --</option>'; // Reset and add placeholder
    ranges.forEach(range => {
      let option = document.createElement("option");
      option.value = range;
      option.textContent = range;
      colorRangeDropdown.appendChild(option);
    });
  };

  // Function to populate color family dropdown
  const populateColorFamilyDropdown = function(range) {
    const families = getColorFamiliesByRange(range);
    colorFamilyDropdown.innerHTML = '<option value="">-- Choose a Family --</option>'; // Reset family dropdown
    families.forEach(family => {
      let option = document.createElement("option");
      option.value = family;
      option.textContent = family;
      colorFamilyDropdown.appendChild(option);
    });
    colorFamilySection.style.display = "block"; // Show family section
  };

  function getBrightness(hex) {
  // Remove the '#' if it exists
  hex = hex.replace('#', '');

  // Parse the hex color into its R, G, and B components
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);

  // Calculate the brightness (YIQ formula)
  return (r * 299 + g * 587 + b * 114) / 1000;
}
const displayColorSwatches = function(colors) {
  colorSwatchContainer.innerHTML = ''; // Reset swatch container
  colors.forEach(color => {
    console.log('Hex Value:', color.hex); // Log hex value to check if it's being retrieved correctly

    const swatchContainer = document.createElement("div");
    swatchContainer.style.width = "100px";
    swatchContainer.style.margin = "10px";
    swatchContainer.style.textAlign = "center";
    swatchContainer.style.cursor = "pointer";

    // Create label to show color name and code and apply background color
    const label = document.createElement("div");
    label.style.backgroundColor = `#${color.hex}`; // Apply the hex code as background color
    label.style.width = "100%";
    label.style.height = "100px";
    label.style.border = "1px solid #ccc";
    label.style.fontSize = "14px";

    // Calculate brightness and adjust text color
    const brightness = getBrightness(color.hex);
    if (brightness < 128) {
      label.style.color = "white"; // Set text color to white if background is dark
    } else {
      label.style.color = "black"; // Set text color to black if background is light
    }

    // Set the text content
    label.textContent = `${color.name} (${color.code})`;

    // Append the label to the container
    swatchContainer.appendChild(label);

    // Add click event to update custom color
    swatchContainer.addEventListener("click", function() {
      customColor = `${color.name} (${color.code})`; // Save the selected color
      customColorHiddenInput.value = customColor; // Update hidden input with color
      customColorDisplayLink.textContent = `Custom Colour: ${customColor}`; // Update display link with selected color

      // Update the link text with the selected color
    customColorDisplayLink.textContent = `Custom Colour: ${customColor}`;
    customColorDisplayLink.style.color = `#${color.hex}`; // Change link color to the selected custom color
      
      // Close the modal
      closeModal();

      // Show the disclaimer
      if (customColorDisclaimer) {
        customColorDisclaimer.style.display = "block";
      }

      // Force select the tinted variant
      forceSelectTintedVariant(); 
    });

    // Add swatch container to the swatch section
    colorSwatchContainer.appendChild(swatchContainer);
  });
  colorSwatchSection.style.display = "block"; // Show the swatch section
};


  // Event listeners for dropdown changes
  colorRangeDropdown.addEventListener("change", function() {
    const selectedRange = colorRangeDropdown.value;
    if (selectedRange) {
      populateColorFamilyDropdown(selectedRange); // Populate family dropdown
      colorSwatchSection.style.display = "none"; // Hide swatches if the range changes
    }
  });

  colorFamilyDropdown.addEventListener("change", function() {
    const selectedRange = colorRangeDropdown.value;
    const selectedFamily = colorFamilyDropdown.value;
    if (selectedFamily) {
      const colors = getColorsByFamily(selectedRange, selectedFamily); // Get colors for selected family
      displayColorSwatches(colors); // Display swatches
    }
  });

  // Function to open the modal
  const openModal = function() {
    customColorModal.style.display = "block";
    modalOverlay.style.display = "block";
    if (customColor) {
      modalColorInput.value = customColor; // Pre-fill modal input if custom color is already selected
    }
  };

  // Function to close the modal
  const closeModal = function() {
    customColorModal.style.display = "none";
    modalOverlay.style.display = "none";
  };

  // Function to force select the "tinted" variant
  const forceSelectTintedVariant = function() {
    colorVariantButtons.forEach(function(button) {
      if (button.value.trim().toLowerCase() === "tinted") {
        button.checked = true; // Select the tinted variant
        button.dispatchEvent(new Event('change', { bubbles: true })); // Trigger change event
      }
    });
  };

  // Function to check if "tinted" is selected and open the modal
  const checkTintedSelection = function() {
    colorVariantButtons.forEach(function(button) {
      if (button.checked && button.value.trim().toLowerCase() === "tinted") {
        openModal(); // Open modal if tinted is selected
      }
    });
  };

  // Event listeners for variant changes and custom color link click
  colorVariantButtons.forEach(function(button) {
    button.addEventListener("change", checkTintedSelection);
  });

  if (customColorDisplayLink) {
    customColorDisplayLink.addEventListener("click", function(event) {
      event.preventDefault(); // Prevent default link behavior
      openModal(); // Open the color picker modal
    });
  }

  // Modal submit button handler
  if (modalSubmitButton && modalColorInput) {
    modalSubmitButton.addEventListener("click", function() {
      const inputValue = modalColorInput.value.trim();
      if (inputValue) {
        customColor = inputValue; // Save the custom color
        customColorHiddenInput.value = customColor; // Update hidden input field
        forceSelectTintedVariant(); // Force select tinted variant
        closeModal(); // Close modal
        customColorDisplayLink.textContent = `Custom Colour: ${customColor}`; // Update clickable link text
        if (customColorDisclaimer) {
          customColorDisclaimer.style.display = "block"; // Show disclaimer
        }
      } else {
        alert("Please enter a color before submitting.");
      }
    });
  }

  // Close modal if clicking outside
  if (modalOverlay) {
    modalOverlay.addEventListener("click", closeModal);
  }

  // Ensure custom color is added as a line item property when adding to cart
  if (addToCartForm) {
    addToCartForm.addEventListener("submit", function(event) {
      if (customColor && customColorHiddenInput) {
        customColorHiddenInput.value = customColor; // Ensure hidden input has the custom color
      }
    });
  }

  // Initialize by fetching CSV data
  fetchCSVData(); // Fetch and parse CSV when page loads
});


